<template>
  <div v-show="itsOpen"  :class="itsOpen ? 'transition-opacity h-72 ease-in opacity-100' : 'h-0'" class=" bg-white opacity-30 w-full absolute right-0 -bottom-56 overflow-scroll z-20 shadow-2xl rounded-lg">
      <div class="title-block flex items-center justify-between py-3 px-4 mb-4 bg-platinumMild text-yank border-b border-platinum">
        <h3 class="font-light font-overpass text-xl my-2 select-none">{{title}}</h3>
      </div>
      <slot name="content" >

      </slot>
  </div>
</template>

<script>
export default {
name:'DropDown',

props: {
    itsOpen: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        require: true
    },
},
}
</script>